module.exports = __webpack_public_path__ + "img/emoji-3.c6ebdc56.png";